import React from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Articles from './pages/Articles';
import Login from './pages/LoginPage';
import Products from './pages/Products';
import PrivateRoute from './components/PrivateRoute'; // Import PrivateRoute for protecting routes
import Locations from './pages/Locations';
import Categories from './pages/Categories';
import Menus from './pages/Menus';
import POS from './pages/POS';
import Kitchen from './pages/OrderManagement';
import Display from './pages/CustomerDisplay';
import Attendance from './pages/Attendance';
import Roles from './pages/RolesManager';
import Layout from './components/Layout';
import OrgManager from './pages/Organizations';
import UsersManager from './pages/UsersManager';
import LocationsWithTerminals from './pages/LocationsWithTerminals';
import OrderStats from './pages/OrderStats';
import AttendanceStats from './pages/AttendanceStats';
import { OrgProvider } from './context/OrgContext'; // Adjust path as needed
import AccountDetails from './pages/AccountDetails';
import Operations from './pages/Operations';
import IDQR from './pages/IDQR';
import Inventory from './pages/Inventory';

function App() {
  console.log('Google Client ID:', process.env.REACT_APP_GOOGLE_CLIENT_ID);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/pos" element={<POS />} />
        <Route path="/attendance" element={<Attendance />} />

        {/* Private Routes Wrapped with OrgProvider and Layout */}
        <Route element={
          <PrivateRoute>
            <OrgProvider>
              <Layout />
            </OrgProvider>
          </PrivateRoute>
        }>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/products" element={<Products />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/menus" element={<Menus />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/orgs" element={<OrgManager />} />
          <Route path="/users" element={<UsersManager />} />
          <Route path="/choosepos" element={<LocationsWithTerminals />} />
          <Route path="/orderstats" element={<OrderStats />} />
          <Route path="/attendancestats" element={<AttendanceStats />} />
          <Route path="/account-details" element={<AccountDetails />} />
          <Route path="/inventory" element={<Inventory />} />

        </Route>

        {/* Private Routes Without Layout but with OrgProvider */}
        <Route element={
          <PrivateRoute>
            <OrgProvider>
              <Outlet/>
            </OrgProvider>
          </PrivateRoute>
        }>
          <Route path="/kitchen" element={<Kitchen />} />
          <Route path="/display" element={<Display />} />
          <Route path="/ops" element={<Operations />} />
          <Route path="/idqr" element={<IDQR/>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
